export default defineNuxtPlugin({
  name: 'dark-mode',
  setup() {
    if (typeof window === 'undefined') return;

    // 检测系统偏好设置
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

    // 根据系统偏好设置 dark class
    const updateDarkMode = (isDark: boolean) => {
      const html = document.documentElement;
      if (isDark) {
        html.classList.add('dark');
      } else {
        html.classList.remove('dark');
      }
    };

    // 立即执行，避免闪烁
    updateDarkMode(prefersDark.matches);

    // 监听系统偏好变化
    if (prefersDark.addEventListener) {
      prefersDark.addEventListener('change', (e) => {
        updateDarkMode(e.matches);
      });
    } else {
      // 兼容旧版浏览器
      prefersDark.addListener((e) => {
        updateDarkMode(e.matches);
      });
    }
  },
});
